import { http } from "./http.js";

async function getContactPerson(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updateContactPerson(resource, id, contactPerson) {
  const response = await http.put(`/${resource}/${id}`, contactPerson);
  return response;
}

async function createContactPerson(resource, contactPerson) {
  const response = await http.post(`/${resource}`, contactPerson);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

async function addContactPersonEmail(resource, id, email) {
  const response = await http.patch(`/${resource}/${id}/email`,
    {
      value: email,
    },
  );
  return response;
}

export {
  getContactPerson,
  updateContactPerson,
  createContactPerson,
  changeRemovedState,
  addContactPersonEmail,
};
